import React from 'react';
import { Box, Typography } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import EmailIcon from '@mui/icons-material/Email';
import DescriptionIcon from '@mui/icons-material/Description';
import '@fortawesome/fontawesome-free/css/all.min.css';

const iconSx = { fontSize: '20px', color: '#667085' };

function ExcelIcon({ sx = {} }) {
  return (
    <i
      className="fa-solid fa-file-excel"
      style={{
        fontSize: sx.fontSize || '20px',
        color: sx.color ?? '#217346',
      }}
      aria-hidden
    />
  );
}

function CsvIcon({ sx = {} }) {
  return (
    <i
      className="fa-solid fa-file-csv"
      style={{
        fontSize: sx.fontSize || '20px',
        color: sx.color ?? '#667085',
      }}
      aria-hidden
    />
  );
}

function getDocIcon(doc) {
  const raw = typeof doc === 'string' ? doc : doc.fileName || doc.name || '';
  const lower = (raw || '').toLowerCase();
  if (lower.endsWith('.xlsx') || lower.endsWith('.xls')) {
    return <ExcelIcon sx={{ ...iconSx, color: '#217346' }} />;
  }
  if (lower.endsWith('.csv')) {
    return <CsvIcon sx={iconSx} />;
  }
  if (lower.endsWith('.msg')) {
    return <EmailIcon sx={iconSx} />;
  }
  if (lower.endsWith('.pdf')) {
    return <PictureAsPdfIcon sx={{ ...iconSx, color: '#DC2626' }} />;
  }
  return <DescriptionIcon sx={iconSx} />;
}

const DocumentsList = ({ documents = [], selectedIndex = null, onDocumentClick }) => {
  return (
    <Box>
      <Typography
        sx={{
          fontSize: '16px',
          fontFamily: 'Inter',
          fontWeight: 600,
          mb: 2,
          display: 'flex',
          color: '#192126',
        }}
      >
        Documents
      </Typography>
      {documents.length === 0 ? (
        <Typography
          sx={{
            fontSize: '14px',
            fontFamily: 'Inter',
            fontWeight: 400,
            color: '#667085',
          }}
        >
          No documents available
        </Typography>
      ) : (
        documents.map((doc, index) => {
          const documentName =
            typeof doc === 'string' ? doc : doc.name || doc.fileName || `Document ${index + 1}`;
          const documentId = typeof doc === 'object' ? doc.id || doc.documentId : index;

          return (
            <Box
              key={documentId || index}
              onClick={() => onDocumentClick && onDocumentClick(index, doc)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                p: 1.5,
                mb: 1,
                backgroundColor: index === selectedIndex ? '#FEE2E2' : 'transparent',
                borderRadius: '8px',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#F8F9FA',
                },
              }}
            >
              {getDocIcon(doc)}
              <Typography
                sx={{
                  fontSize: '14px',
                  fontFamily: 'Inter',
                  fontWeight: 400,
                  color: '#192126',
                }}
              >
                {documentName}
              </Typography>
            </Box>
          );
        })
      )}
    </Box>
  );
};

export default DocumentsList;
